<template>
    <div class="component cursor-pointer" @click="addCustomer" id="customer-in-out-realtime">
        <div
            :class="{'vx-card p-2 bg-unknown' : data.faceType == 'unknown', 'vx-card p-2 bg-success' : data.faceType == 'employee' || data.faceType == 'loyalty-customer'}">
            <div class="vx-row">
                <div class="vx-col md:w-5/12 w-full text-center">
                    <div class="component w-full">
                        <img class="round" width="80" height="80" :src="data.imageUrl ? data.imageUrl : imageDefault"
                             alt="">
                    </div>
                </div>
                <div class="vx-col md:w-7/12 w-full pl-2 m-auto">
                    <div class="w-full md:text-left text-center  ">
                        <span class="font-bold text-white text-base" v-if="data.faceType !== 'unknown'"
                              style="font-size:18px">{{ data.fullName  }}</span>
                        <br v-if="data.faceType !== 'unknown'"/>
                        <span class="font-bold text-white text-base" v-else
                              style="font-size:18px">Không xác định</span>
                        <br v-if="data.faceType === 'unknown'"/>
                        <small class="text-white">{{ data.checkinTime }}</small>
                        <br v-if="data.serviceBookingName"/>
                        <small class="text-white" v-if="data.serviceBookingName">{{ data.serviceBookingName }}</small>
                        <br v-if="data.timeBooking"/>
                        <small class="text-white" v-if="data.timeBooking">{{ data.timeBooking }}</small>
                        <br v-if="data.noteCustomerType"/>
                        <small class="text-white" v-if="data.noteCustomerType">{{ data.noteCustomerType }}</small>
                    </div>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="component w-full " v-if="data.faceType !== 'unknown'">
                        <small class="text-white">{{ data.cardRankName }}</small>
                    </div>
                </div>
            </div>
        </div>

        <vs-popup class="holamundo customer-info" title="Khách hàng" :active.sync="popupInfo" id="customer_info_popup_in_out"
                  v-if="popupInfo">
            <vs-tabs v-model="activeTab">
                <vs-tab label="Thông tin khách hàng">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <CustomerInformation :loyaltyCustomerId="data.employeeId"></CustomerInformation>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử cuộc gọi">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <CallHistory :loyaltyCustomerId="data.employeeId"></CallHistory>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử tư vấn">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <ConsultingStep :loyaltyCustomerId="data.employeeId"></ConsultingStep>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử thanh toán">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <FeeCollectionStep :loyaltyCustomerId="data.employeeId"></FeeCollectionStep>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử điều trị">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <SubclinicalStep :loyaltyCustomerId="data.employeeId"></SubclinicalStep>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử nhắn tin">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <HistorySMS :loyaltyCustomerId="data.employeeId"></HistorySMS>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử ra vào">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <InOutHistory :loyaltyCustomerId="data.employeeId"></InOutHistory>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử đặt lịch">
                    <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         :settings="settings">
                        <BookingHistory :loyaltyCustomerId="data.employeeId"></BookingHistory>
                    </VuePerfectScrollbar>
                </vs-tab>
            </vs-tabs>
            <div class="vx-row mt-4">
                <div class="vx-col w-full">
                    <div class="flex flex-wrap justify-end gap-4">
                        <vs-button icon-pack="feather" icon="icon-calendar" @click="openPopupBooking"
                                   v-if="isPermissionCreateBooking">Đặt lịch
                        </vs-button>
                        <vs-button icon-pack="feather" icon="icon-phone-call" @click="callToCustomer(null)"
                                   v-if="userInfo.userRole == 'user' && isPermissionCall">Gọi điện
                        </vs-button>
                        <vs-button icon-pack="feather" icon="icon-mail" @click="sendSMS">Gửi SMS</vs-button>
                        <vs-button icon-pack="feather" icon="icon-x" color="danger" type="border"
                                   @click="closePopupInfo">Đóng
                        </vs-button>
                    </div>
                </div>
            </div>

            <vs-popup class="holamundo" title="Gửi SMS" :active.sync="popupSendSMSCustomer" id="send_sms_customer">
                <div class="vx-row">
                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">Tổng đài</label>
                        <v-select class="w-full" v-model="smsSendInfo.smsBrandNameId"
                                  :options="brandNameOptions" :reduce="item => item.value">
                        </v-select>
                    </div>
                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">Nội dung</label>
                        <vs-textarea class="w-full" v-model="smsSendInfo.messageTitle"/>
                    </div>
                    <div class="vx-col w-full">
                        <div class="flex justify-end gap-4">
                            <vs-button icon-pack="feather" icon="icon-send" @click="send">Gửi</vs-button>
                            <vs-button icon-pack="feather" icon="icon-x" type="border" color="danger"
                                       @click="cancelSend">Hủy
                            </vs-button>
                        </div>
                    </div>
                </div>
            </vs-popup>
            <vs-popup class="holamundo" title="Đặt lịch" :active.sync="popupBooking" id="popup_beauty_booking"
                      v-if="popupBooking">
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <label class="vs-input--label required">Chi nhánh</label>
                        <v-select v-model="selectedBranchCreate" :options="branchCreateOptions" :clearable="false"
                                  v-validate="'required'" name="branch">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                    </div>
                    <div class="vx-col w-full mt-6">
                        <vs-radio v-model="packageType" vs-value="1" class="mr-4"
                                  @change="changeSelectType">Nhóm dịch vụ
                        </vs-radio>
                        <vs-radio v-model="packageType" vs-value="2"
                                  @change="changeSelectType">Gói dịch vụ
                        </vs-radio>
                    </div>
                    <div class="vx-col w-full mt-4" v-if="packageType == 1">
                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <label class="vs-input--label required">Nhóm dịch vụ</label>
                                <v-select v-model="selectBeautyService" :options="beautyServiceData" :clearable="false"
                                          v-validate="''" name="nameServiceType">
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                                <!-- <span class="text-danger text-sm">{{ errors.first('nameServiceType') }}</span> -->
                            </div>
                            <div class="vx-col w-full mt-4">
                                <label class="vs-input--label required">Dịch vụ</label>
                                <v-select v-model="selectBeautyServicePackage" :options="beautyServicePackageOptions"
                                          :clearable="false" v-validate="''" name="nameServicePacks">
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                                <!-- <span class="text-danger text-sm">{{ errors.first('nameServicePacks') }}</span> -->
                            </div>
                            <div class="vx-col w-full mt-4">
                                <label class="vs-input--label">Bác sĩ</label>
                                <v-select class="w-full" v-model="selectedDoctorCreate" :options="doctorCreateOptions"
                                          :clearable="false" v-validate="''" name="doctor">
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors.first('doctor') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col w-full mt-4" v-if="packageType == 2">
                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <label class="vs-input--label required">Gói dịch vụ</label>
                                <v-select v-model="selectedComboService" :options="beautyComboService"
                                          :clearable="false"
                                          v-validate="''" name="comboService">
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                                <!-- <span class="text-danger text-sm">{{ errors.first('comboService') }}</span> -->
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-1/2 mt-4">
                        <label class="vs-input--label">Ngày</label>
                        <div class="w-full">
                            <datepicker :highlighted="highlighted" class="w-full" :language="vi"
                                        :format="'dd/MM/yyyy'" v-model="selectDate"
                                        data-vv-validate-on="input" ref="datepickBooking" v-validate="'required'"
                                        name="time">
                            </datepicker>
                            <span class="text-danger text-sm">{{ errors.first('time') }}</span>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-1/2 mt-4">
                        <label class="vs-input--label">Giờ</label>
                        <div class="w-full">
                            <flat-pickr :config="configTimePickerBooking" v-model="selectTime"
                                        class="w-full vs-inputx vs-input--input normal" name="time"></flat-pickr>
                        </div>
                    </div>
                    <div class="vx-col w-full mt-4">
                        <div class="flex flex-wrap float-right">
                            <vs-button color="primary" class="mt-6 text-center mr-2"
                                       @click="saveBooking"
                                       :disabled="!validateForm">Tạo mới
                            </vs-button>
                            <vs-button color="warning" type="border" class="mt-6 text-center"
                                       @click="popupBooking = false">Hủy
                            </vs-button>
                        </div>
                    </div>
                </div>
            </vs-popup>
        </vs-popup>
    </div>
</template>

<script>
import {isAPI} from "@/store/permission";
import {constAPI} from "@/store/constant";
import ConsultingStep from "../../customer/cell-renderer/medical-step/ConsultingStep";
import FeeCollectionStep from "../../customer/cell-renderer/medical-step/FeeCollectionStep";
import SubclinicalStep from "../../customer/cell-renderer/medical-step/SubclinicalStep";
import HistorySMS from "../../customer/cell-renderer/history-sms/HistorySMS";
import InOutHistory from "../../customer/cell-renderer/medical-step/InOutHistory";
import BookingHistory from "../../customer/cell-renderer/medical-step/BookingHistory";
import CustomerInformation from "../../customer/CustomerInformation";
import CallHistory from "../../customer/cell-renderer/medical-step/CallHistory";
import moment from "moment";
import {en, vi} from "vuejs-datepicker/dist/locale";
import vSelect from 'vue-select';
import authConfig from '@/../auth_config.json';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Vietnamese} from 'flatpickr/dist/l10n/vn';
import Datepicker from 'vuejs-datepicker';

export default {
    components: {
        ConsultingStep,
        FeeCollectionStep,
        SubclinicalStep,
        HistorySMS,
        InOutHistory,
        BookingHistory,
        CustomerInformation,
        CallHistory,
        vSelect,VuePerfectScrollbar,
        flatPickr,
        Datepicker,
    },
    props: {
        data: {}
    },
    data() {
        return {
            imageDefault: require('@/assets/images/card/businessman.jpeg'),
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .30,
                suppressScrollX: true,
            },

            activePopupCall: false,
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            popupCreateFile: false,
            createdDate: new Date(),
            configDatePicker: {
                dateFormat: 'd-m-Y',
            },
            customerTypeOptions: [
                {value: 1, label: "Khách hàng cũ tới tái khám"},
                {value: 2, label: "Khách hàng cũ sử dụng dịch vụ"},
                {value: 3, label: "Khách hàng cũ tới tư vấn dv"},
                {value: 4, label: "Khách hàng mới đến tư vấn"},
                {value: 5, label: "Khách hàng tới mua thuốc mỹ phẩm"},
                {value: 6, label: "Khách hàng trả lại thuốc"},
                {value: 7, label: "Khách hàng tới hoàn phí"},
            ],
            selectedCustomerTypeValue: null,
            healthInsuranceNum: null,
            reasonForExamination: null,
            noteReason: null,
            stepOptions: [
                {value: 1, label: 'Tiếp đón'},
                {value: 2, label: 'Tư vấn'},
                {value: 3, label: 'Thu phí'},
                {value: 4, label: 'Cận lâm sàng'},
                {value: 5, label: 'Hoàn thành'},
            ],
            selectedStepValue: null,
            selectedEmployeeValue1: null,
            selectedEmployeeValue2: null,
            selectedDoctorValue: null,
            popupNote: false,
            customerDetails: null,
            popupInfo: false,
            organizationBranchOptions: [],
            customerInfo: {
                id: null,
                code: null,
                fullName: null,
                phoneNumber: null,
                city: null,
                district: null,
                fullAddress: null,
                houseNumber: null,
                birthday: null,
                gender: null,
                email: null,
                ethnic: null,
                job: null,
                country: "Việt Nam",
                firstName: null,
                lastName: null,
                organizationBranchId: null,
                passport: null,
                street: null,
                weight: null,
                sourceType: null,
            },
            images: [],
            user_data: null,
            imagesId: [],
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            disabledFn: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },
            en: en,
            vi: vi,
            genderOptions: [
                {value: null, label: 'Tất cả'},
                {value: 0, label: this.$t('genderOption.unknown')},
                {value: 1, label: this.$t('genderOption.male')},
                {value: 2, label: this.$t('genderOption.female')}
            ],
            customerId: null,
            configDatePickerInfo: {
                dateFormat: 'Z',
                // defaultDate: new Date(),
                locale: Vietnamese,
                maxDate: new Date(),
                altFormat: 'd/m/Y',
                altInput: true,
                wrap: true,
                allowInput: true,
            },
            typeCustomer: [
                {value: 1, label: 'Khách hàng chính thức'},
                {value: 2, label: 'Khách hàng tiềm năng'},
            ],
            sourceTypeOptions: [
                {value: 2, label: 'Nguồn phòng ban'},
                {value: 3, label: 'Nguồn cá nhân'},
            ],
            departmentData: [],
            showSelectedSourceType: false,
            employeeInfo: null,
            autoCreateMedicalRecordCheck: false,


            activeTab: 0,
            brandNameOptions: [],
            popupSendSMSCustomer: false,
            configTimePicker: {
                minDate: new Date(),
                enableTime: true,
                time_24hr: true,
                locale: Vietnamese,
            },
            smsSendInfo: {
                smsBrandNameId: null,
                messageType: null,
                sendTimeStr: null,
                messageTitle: null,
            },

            // Querry
            nanoCustomerCode: null,
            fullName: null,
            gender: null,
            phoneNumber: null,
            sourceType: null,
            job: null,
            fullAddress: null,
            email: null,
            type: null,
            startDateBirthday: null,
            endDateBirthday: null,
            startDateFirstLogin: null,
            endDateFirstLogin: null,
            startDateLastLogin: null,
            endDateLastLogin: null,
            dayBirthday: null,
            monthBirthday: null,
            yearBirthday: null,
            highlightedFn: {
                customPredictor(date) {
                    if (moment(new Date()).format('YYYY-MM-DD') == moment(new Date(date)).format('YYYY-MM-DD')) {
                        return true;
                    }
                }
            },
            disabledDates: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },
            dataCustomerSelected: [],

            //Booking
            branchCreateOptions: [],
            popupBooking: false,
            beautyServicePackageData: [],
            beautyServiceData: [],
            selectBeautyServiceValue: null,
            beautyServicePackageOptions: [],
            selectBeautyServicePackageValue: null,
            selectedDoctorCreateValue: null,
            doctorCreateOptions: [],
            selectedBranchCreateValue: null,
            selectDate: new Date(),
            selectTime: new Date(),
            configTimePickerBooking: {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
                minTime: "07:00",
            },
            packageType: 1,
            beautyComboService: [],
            selectedComboServiceValue: null,
        }
    },

    computed: {
        isPermissionCall() {
            return isAPI(this, constAPI.beauty_call)
        },

        //Booking
        isPermissionCreateBooking() {
            return isAPI(this, constAPI.beauty_booking_create);
        },
        selectedBranchCreate: {
            get() {
                let obj = this.branchCreateOptions.find(x => x.value === this.selectedBranchCreateValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            async set(obj) {
                this.selectedBranchCreateValue = obj ? obj.value : null;
                this.selectBeautyServiceValue = null;
                this.selectedComboServiceValue = null;
                if (this.selectedBranchCreateValue && this.packageType == 1) await this.getBeautyService();
                if (this.selectedBranchCreateValue && this.packageType == 2) await this.getBeautyComboService();
                this.doctorCreateOptions = [];
                await this.$validator.reset();
            }
        },
        selectBeautyService: {
            get() {
                let obj = this.beautyServiceData.find(x => x.value === this.selectBeautyServiceValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectBeautyServiceValue = obj ? obj.value : null;
                this.getBeautyServicePack();
            }
        },
        selectBeautyServicePackage: {
            get() {
                let obj = this.beautyServicePackageOptions.find(x => x.value === this.selectBeautyServicePackageValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectBeautyServicePackageValue = obj ? obj.value : null;
                this.selectedDepartmentCreateValue = obj ? obj.departmentId : null;
                this.getDoctor();
            }
        },
        selectedDoctorCreate: {
            get() {
                let obj = this.doctorCreateOptions.find(x => x.value === this.selectedDoctorCreateValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedDoctorCreateValue = obj ? obj.value : null;
            }
        },
        selectedComboService: {
            get() {
                let obj = this.beautyComboService.find(x => x.value === this.selectedComboServiceValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedComboServiceValue = obj ? obj.value : null;
            }
        },
        validateForm() {
            return !this.errors.any();
        },
    },

    methods: {
        addCustomer() {
            this.$eventBus.$emit("show-details-customer", true)
            if (this.data.faceType === 'unknown' && this.isPermissionCreate) {
                this.$router.push(`/user/add-customer?imageUrl=${this.data.imageUrl}`)
            }

            if (this.data.faceType === 'loyalty-customer') {
                this.popupInfo = true
                setTimeout(() => {
                    let callParent = document.getElementById('customer_info_popup_in_out')
                    if (callParent) {
                        let backgroundCall = callParent.querySelector('.vs-popup--background')
                        if (backgroundCall) callParent.removeChild(backgroundCall);
                    }
                    this.data.employeeId = parseInt(this.data.employeeId)
                }, 500)
                // this.$router.push(`/user/booking-schedule-history?customerId=${e.employeeId}`);
            }
        },

        isPermissionCreate() {
            return isAPI(this, constAPI.customer_loyaly_create)
        },

        callToCustomer(data) {
            let result = data ? data : this.data
            result['isCreateBooking'] = true;
            this.$eventBus.$emit("beauty-call", result);
        },
        openPopupNote(data) {
            this.customerDetails = data;
            this.popupNote = true;
        },
        saveInfoCustomer() {
            this.$vs.loading();
            this.$crm.post(`/loyalty/customer/update-note/${this.customerDetails.id}`, this.customerDetails).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: this.$t('menuCustomer.updateCustomerSS'),
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                });
                this.popupNote = false;
                this.$store.commit('UPDATE_VIP_CUSTOMER', true);
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        //Send SMS
        async sendSMS() {
            await this.getBrandName();
            this.popupSendSMSCustomer = true;
        },
        getBrandName() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/sms-brand-name/get-all').then(res => {
                    if (res.data && res.data.length > 0) {
                        this.brandNameOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.brandName,
                            }
                        })
                    }
                    this.$vs.loading.close();
                    resolve(res);
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        cancelSend() {
            this.smsSendInfo = {
                smsBrandNameId: null,
                messageType: null,
                sendTimeStr: null,
                messageTitle: null,
            }
            this.popupSendSMSCustomer = false;
        },
        send() {
            let payload = {
                messageType: 1,
                loyaltyCustomerIds: [this.data.id],
                message: this.smsSendInfo.messageTitle,
                smsBrandNameId: this.smsSendInfo.smsBrandNameId,
                sendTimeStr: moment(new Date().toISOString()).format('yyyyMMDDHHmmss'),
                sendStatus: 1,
            }
            this.$vs.loading();
            this.$crm.post('/sms-message-config/create', payload).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Gửi tin nhắn thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.cancelSend();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        // End Send

        dateFirstLogin() {
            return new Promise((resolve, reject) => {
                if (this.startDateFirstLogin) this.startDateFirstLogin = new Date(new Date(this.startDateFirstLogin).setHours(0, 0, 0, 0));
                if (this.endDateFirstLogin) this.endDateFirstLogin = new Date(new Date(this.endDateFirstLogin).setHours(0, 0, 0, 0));
                if (this.startDateFirstLogin && this.endDateFirstLogin && (this.startDateFirstLogin.getTime() > this.endDateFirstLogin.getTime())) {
                    reject();
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: 'Ngày bắt đầu không được lớn hơn ngày kết thúc',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                resolve();
            })
        },

        dateLastLogin() {
            return new Promise((resolve, reject) => {
                if (this.startDateLastLogin) this.startDateLastLogin = new Date(new Date(this.startDateLastLogin).setHours(0, 0, 0, 0));
                if (this.endDateLastLogin) this.endDateLastLogin = new Date(new Date(this.endDateLastLogin).setHours(0, 0, 0, 0));
                if (this.startDateLastLogin && this.endDateLastLogin && (this.startDateLastLogin.getTime() > this.endDateLastLogin.getTime())) {
                    reject();
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: 'Ngày bắt đầu không được lớn hơn ngày kết thúc',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                resolve();
            })
        },

        openPopupBooking() {
            this.$validator.reset();
            this.selectedStatusBeautyValue = null;
            this.selectedBranchCreateValue = null;
            this.selectedCustomerCreateValue = null;
            this.selectBeautyServiceValue = null;
            this.selectBeautyServicePackageValue = null;
            this.selectedDoctorCreateValue = null;
            this.selectedDepartmentCreateValue = null;
            this.selectBeautyServicePackageValue = null;
            this.selectedComboServiceValue = null;

            this.beautyServicePackageOptions = [];
            this.beautyServiceData = [];
            this.doctorCreateOptions = [];
            this.beautyComboService = [];

            this.selectDate = new Date();
            this.selectTime = new Date();

            this.branchCreateOptions = this.branchOptions.filter(x => x.value);

            this.popupBooking = true;
        },

        async changeSelectType() {
            this.selectBeautyServiceValue = null;
            this.selectBeautyServicePackageValue = null;
            this.selectedDoctorCreateValue = null;
            this.selectedDepartmentCreateValue = null;
            this.selectBeautyServicePackageValue = null;
            this.selectedComboServiceValue = null;

            if (this.selectedBranchCreateValue && this.packageType == 1) await this.getBeautyService();
            if (this.selectedBranchCreateValue && this.packageType == 2) await this.getBeautyComboService();
        },

        getBeautyService(dataService, organizationBranchId) {
            return new Promise((resolve, reject) => {
                this.beautyServiceData = [];
                let payload = {
                    organizationBranchId: !this.isUpdateBooking ? this.selectedBranchCreateValue : organizationBranchId,
                    keySearch: dataService ? dataService.beautyService.name : null,
                }
                this.$vs.loading();
                this.$crm.post('/beauty-service/find-by-condition', payload).then(res => {
                    res.data.content.map(x => {
                        let data = this.beautyServiceData.find(t => t.value == x.id);
                        if (!data) {
                            let result = {
                                value: x.id,
                                label: x.code + '-' + x.name,
                            }
                            this.beautyServiceData.push(result);
                        }
                    })
                    this.beautyServiceData = Array.from(new Set(this.beautyServiceData));
                    resolve()
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getBeautyServicePack() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let payload = {
                    organizationBranchId: this.selectedBranchCreateValue,
                    beautyServiceId: this.selectBeautyServiceValue,
                    active: this.isUpdateBooking ? -1 : null,
                };
                this.$crm.post('beauty-service-package-department/find-by-condition', payload).then(res => {
                    this.beautyServicePackageOptions = res.data.content.map(el => {
                        return {
                            value: el.beautyServicePackage.id,
                            label: el.beautyServicePackage.code + '-' + el.beautyServicePackage.name,
                            departmentId: el.beautyServicePackage.departmentId,
                        }
                    })
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getBeautyComboService() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/beauty-package-combo/find-by-condition', {organizationBranchId: this.selectedBranchCreateValue}).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.beautyComboService = res.data.content.map(x => {
                            return {
                                label: x.code + '-' + x.name,
                                value: x.id
                            };
                        });
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getDoctor() {
            return new Promise((resolve, reject) => {
                let url = '/beauty-booking/get-list-doctor-department';
                this.doctorCreateOptions = [];
                if (this.selectedBranchCreateValue) {
                    url += '?organizationBranchId=' + this.selectedBranchCreateValue
                }
                if (this.selectedDepartmentCreateValue) {
                    url += '&departmentId=' + this.selectedDepartmentCreateValue
                }

                this.$vs.loading();
                this.$crm.get(url).then(res => {
                    if (res.data.data && res.data.data.length > 0) {
                        this.doctorCreateOptions = res.data.data.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName
                            }
                        });
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        async saveBooking(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            if (this.packageType == 1 && !this.selectBeautyServicePackageValue) {
                return this.$vs.notify({
                    text: 'Dịch vụ là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if (this.packageType == 2 && !this.selectedComboServiceValue) {
                return this.$vs.notify({
                    text: 'Gói dịch vụ là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',

                    color: 'danger'
                });
            }

            let payload = {
                organizationBranchId: this.selectedBranchCreateValue,
                loyaltyCustomerId: this.data.id,
                isDoctorCreate: true,
                packageType: this.packageType,
                presentStatus: 0,
                beautyBookingDetails: [
                    {
                        beautyServicePackageId: this.selectBeautyServicePackageValue,
                        bookingDate: new Date(new Date(this.selectDate).setUTCHours(0, 0, 0, 0)).toISOString(),
                        performerId: this.selectedDoctorCreateValue,
                        startTime: this.selectTime,
                        beautyPackageComboId: this.selectedComboServiceValue,
                    }
                ]
            }

            let checkDate = new Date(new Date(this.selectDate).setHours(parseInt(this.selectTime.substr(0, 2)), parseInt(this.selectTime.substr(3, 2)), 0));
            if (checkDate < new Date()) {
                return this.$vs.notify({
                    text: 'Thời gian đặt lịch không hợp lệ!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            this.$vs.loading();
            this.$crm.post('/beauty-booking/create', payload).then(() => {
                this.$vs.notify({
                    text: `Tạo mới lịch hẹn thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                })
                this.popupBooking = false;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        closePopupInfo() {
            this.popupInfo = false
            this.$eventBus.$emit("show-details-customer", false);
        }
    },
}
</script>

<style lang="scss">
.bg-unknown {
    background-color: #eb5455d1;
}

#customer-in-out-realtime {

    .ag-grid-cell-chip-customer {
        &.vs-chip-success {
            background: rgba(var(--vs-success), .2);
            color: rgba(var(--vs-success), 1) !important;
            font-weight: 500;
        }

        &.vs-chip-warning {
            background: rgba(var(--vs-warning), .2);
            color: rgba(var(--vs-warning), 1) !important;
            font-weight: 500;
        }
    }
}

.consultation_call {
    .vs-popup--header {
        //display: none;
    }

    .vs-popup--content {
        padding: 0 !important;
        margin: 0 !important;
        width: 100% !important;
    }

    .view_details_call {
        .vx-row {
            margin: 0 !important;
        }
    }
}

#customer_note {
    .vs-con-textarea {
        height: 300px;

        textarea {
            height: 300px;
        }
    }
}

#customer_info_popup_in_out {
    background: rgba(0, 0, 0, .4);

    .vs-popup--header {
        display: none;
    }

    .vs-popup {
        width: 80%;
    }

    .vs-textarea {
        height: 200px;
    }

    .vs-popup--content {
        min-height: 500px;

        .con-slot-tabs {
            min-height: 500px;
        }
    }

    .scroll-area--nofications-dropdown, .scroll-area--cart-items-dropdowm {
        max-height: 40rem;
    }

    .flip-card {
        background-color: transparent;
        width: 300px;
        height: 150px;
        perspective: 1000px;
        font-family: sans-serif;
    }

    .title {
        font-size: 1.5em;
        font-weight: 900;
        text-align: center;
        margin: 0;
    }

    .flip-card-inner {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
        transition: transform 0.8s;
        transform-style: preserve-3d;
    }

    .flip-card:hover .flip-card-inner {
        transform: rotateY(180deg);
    }

    .flip-card-front, .flip-card-back {
        box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.2);
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        border-radius: 1rem;
    }

    .flip-card-back {
        transform: rotateY(180deg);
    }
}

#popup-history-call,
#popup-history-call-record {
    .vs-popup--header {
        display: none;
    }
}

.nostar_desc {
    display: none !important;
}

#call_history {
    min-height: 400px;
}

#popup_beauty_booking {
    z-index: 54000 !important;
}
</style>
